module.exports = __webpack_public_path__ + "img/vote.804cc301.png";